module.exports = __webpack_public_path__ + "static/media/test-file.08b72857.pdf";